import { Navigate } from 'react-router-dom';
import { useUserContext } from '@/context';
import { Routes } from '@/routes';

export interface PermissionProps {
  children: React.ReactElement;
  oneOf?: SamadRole[];
  required?: SamadRole | SamadRole[];
  fallback?: string;
  fallbackView?: React.ReactElement;
}

export default function Permission({
  children,
  required = [],
  oneOf = [],
  fallback = '/',
  fallbackView = undefined
}: PermissionProps) {

  const { roles } = useUserContext();
  if (typeof required === 'string') {
    required = [required];
  }

  for (const item of required) {
    if (!roles.includes(item)) {
      if (fallbackView) return fallbackView;
      return <Navigate to={fallback ?? Routes.Home} />;
    }
  }

  if (oneOf.length === 0) return children;

  for (const item of oneOf) {
    if (roles.includes(item)) {
      return children;
    }
  }

  if (fallbackView) return fallbackView;
  return <Navigate to={fallback ?? Routes.Home} />;
}
